import { z } from 'zod';
import { kuralEylemleriSchema } from '../envanter/kural-eylemleri.js';

/**
 * §7.5 / §15.4 — "Envanter Güncelleme Ayarları" ekranının şeması.
 * Alan adları şartnamedeki DB alanlarıyla birebir eşleşir.
 */

export const sameSellerMatchSchema = z.enum(['EXACT', 'SIMILAR_90', 'SIMILAR_75', 'SIMILAR_50']);
export const unverifiedSourceActionSchema = z.enum(['SET_QTY_ZERO', 'GO_INACTIVE']);
export const deleteRuleActionSchema = z.enum([
  'NOTHING',
  'REMOVE_FROM_INVENTORY',
  'REMOVE_AND_BLACKLIST',
]);

export const updateInventorySettingsSchema = z.object({
  // Şunları Liste Dışı Bırak
  excludeTrademark: z.boolean().optional(),
  excludeSellerBranded: z.boolean().optional(),
  excludeBlacklistedBrand: z.boolean().optional(),
  excludeBlacklistedKeyword: z.boolean().optional(),
  excludePrime: z.boolean().optional(),
  excludeSba: z.boolean().optional(),
  excludeFba: z.boolean().optional(),
  excludeFbm: z.boolean().optional(),
  excludeDigital: z.boolean().optional(),
  excludeChineseSeller: z.boolean().optional(),

  // Satış mağazası (JP) filtre ayarları
  jpSellerCountMin: z.number().int().min(0, 'Satıcı sayısı negatif olamaz.').max(999).optional(),
  jpSellerCountMax: z
    .number()
    .int()
    .min(1, 'Satıcı sayısı üst sınırı en az 1 olmalı.')
    .max(999)
    .optional(),
  jpExcludeIfPrime: z.boolean().optional(),
  jpExcludeIfAmazon: z.boolean().optional(),
  jpExcludeIfFba: z.boolean().optional(),
  jpExcludeIfSameSeller: z.boolean().optional(),
  jpSameSellerMatch: sameSellerMatchSchema.optional(),
  jpExcludeIfChinese: z.boolean().optional(),
  jpExcludeIfBlacklistedSeller: z.boolean().optional(),

  // Kargo / vergi opsiyonları
  useRegionAverageShipping: z.boolean().optional(),
  includeDiscountedPrice: z.boolean().optional(),
  includePrimeDiscountedPrice: z.boolean().optional(),
  includeExtraTax10: z.boolean().optional(),
  isTaxRegisteredInSaleCountry: z.boolean().optional(),

  // Şunları Sil (3 seviyeli)
  deleteWhenRemovedFromAmazon: deleteRuleActionSchema.optional(),
  deleteOnFairPricingWarning: deleteRuleActionSchema.optional(),
  deleteOnRestrictedProductsRemoval: deleteRuleActionSchema.optional(),
  deleteOnProblemProductNotice: deleteRuleActionSchema.optional(),

  // Ortak havuz
  poolAddBrandFromMine: z.boolean().optional(),
  poolAddBrandFromPool: z.boolean().optional(),
  poolAddProductFromMine: z.boolean().optional(),
  poolAddProductFromPool: z.boolean().optional(),

  // ⭐ Güvenlik ağı (§11.6)
  maxStalenessHours: z
    .number()
    .int()
    .min(1, 'En az 1 saat olmalı.')
    .max(720, 'En fazla 720 saat (30 gün) olabilir.')
    .optional(),
  unverifiedSourceActionHours: z
    .number()
    .int()
    .min(1, 'En az 1 saat olmalı.')
    .max(720, 'En fazla 720 saat olabilir.')
    .optional(),
  unverifiedSourceAction: unverifiedSourceActionSchema.optional(),
  sourceErrorCountThreshold: z.number().int().min(1).max(100).optional(),

  /** 22 Eki 2026 — kural başına "dokunma / stok 0 / Amazon'dan kaldır" (bkz. kural-eylemleri). */
  kuralEylemleri: kuralEylemleriSchema.optional(),

  /** 22 Eki 2026 — fiyatlar yalnız bu saatlerde gönderilsin (Türkiye saati, bkz. fiyat-saatleri). */
  fiyatSaatKisiti: z.boolean().optional(),
  fiyatSaatBaslangic: z
    .number()
    .int()
    .min(0, 'Saat 0-23 olmalı.')
    .max(23, 'Saat 0-23 olmalı.')
    .optional(),
  fiyatSaatBitis: z
    .number()
    .int()
    .min(0, 'Saat 0-23 olmalı.')
    .max(23, 'Saat 0-23 olmalı.')
    .optional(),
  fiyatSaatArtisSerbest: z.boolean().optional(),

  // SKU şablonu
  skuPrefix: z
    .string()
    .min(1, 'SKU öneki boş olamaz.')
    .max(12, 'SKU öneki en fazla 12 karakter olabilir.')
    .regex(/^[A-Za-z0-9-]+$/, 'SKU öneki yalnızca harf, rakam ve tire içerebilir.')
    .optional(),
});
export type UpdateInventorySettingsInput = z.infer<typeof updateInventorySettingsSchema>;
